$(document).ready(function() {

    const body = $(document.body);
    // A button on Product Overview that controls visibiilty of product-category filters on mobile.
    body.on('click', '.js-button-category-filter', (e) => {
        e.preventDefault();
        body.toggleClass('is-filter-categories-visible');
    });

});
